module.exports = __webpack_public_path__ + "static/media/first-view-mockup.f33b05d3.png";